import { render, staticRenderFns } from "./GrossWeightPopover.vue?vue&type=template&id=10b337f6&scoped=true&"
import script from "./GrossWeightPopover.vue?vue&type=script&lang=js&"
export * from "./GrossWeightPopover.vue?vue&type=script&lang=js&"
import style0 from "./GrossWeightPopover.vue?vue&type=style&index=0&id=10b337f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b337f6",
  null
  
)

export default component.exports